import { ApiModule } from '~/clientApi/ApiModule';

const MODULE = 'settings';
const extraEndpoints = {};

const settings = (apiInstance) =>
  new ApiModule(apiInstance, MODULE, extraEndpoints);

export default settings;
